import type { Company } from '../lib/types.ts';

const DAY_MS = 24 * 60 * 60 * 1000;

export function ExpiryBanner({ company }: { company: Company }) {
  if (!company.expires_at) return null;
  if (company.status !== 'compliant') return null;
  const ms = new Date(company.expires_at).getTime() - Date.now();
  const days = Math.ceil(ms / DAY_MS);
  if (days > 60) return null;

  const expired = days <= 0;
  const cls = expired
    ? 'border-red-200 bg-red-50 text-red-800'
    : days <= 14
      ? 'border-orange-200 bg-orange-50 text-orange-800'
      : 'border-amber-200 bg-amber-50 text-amber-800';

  const message = expired
    ? `Your compliance expired on ${new Date(company.expires_at).toLocaleDateString()}.`
    : days <= 1
      ? 'Your compliance expires today.'
      : `Your compliance expires in ${days} days (${new Date(company.expires_at).toLocaleDateString()}).`;

  return (
    <div className={`mx-auto w-full max-w-3xl px-4 pt-4`}>
      <div className={`rounded-lg border px-4 py-3 text-sm ${cls}`}>
        <span className="font-medium">{expired ? 'Compliance expired.' : 'Renewal due.'}</span>{' '}
        <span>{message} Please review and resubmit your questionnaire.</span>
      </div>
    </div>
  );
}
